export default "__VITE_ASSET__2dc0ec0a__"